import App from "./App";
import BudgetCalculatorApp from "./BudgetCalculatorApp";
import { convertReact2WebComponent } from "./convertReactToWebStyledComponent";

// Use shadow DOM in production, but not in development for better HMR
const useShadowDom = import.meta.env.MODE === "production";

const JobRadRechnerApp = convertReact2WebComponent(App, {
  props: {
    apiUrl: "string",
    signUpUrl: "string",
    ctaUrl: "string",
    calculatorEnv: "string",
    showHeader: "string",
    showBudgetCalculator: "string",
  },
  shadow: useShadowDom ? "open" : undefined,
});

customElements.define("jobrad-rechner", JobRadRechnerApp);

const JobRadBudgetRechner = convertReact2WebComponent(BudgetCalculatorApp, {
  props: {
    apiUrl: "string",
    calculatorEnv: "string",
    showHeader: "string",
  },
  shadow: useShadowDom ? "open" : undefined,
});

customElements.define("jobrad-budgetrechner", JobRadBudgetRechner);

export default JobRadRechnerApp;
